<template>
  <footer id="footer" class="footer" name="footer">
    <div class="container">
      <a-typography-title :level="1">
        <span>If you have any questions, please leave your contact</span>
        <br v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)" />
        <span>info below and we will get back to you as soon as possible.</span>
      </a-typography-title>
      <a-form ref="form" class="box_form" layout="vertical"
              :model="form.data" :rules="form.rule">
        <a-row>
          <a-col :xs="24" :md="12" :xl="4">
            <a-form-item name="name" has-feedback>
              <a-input v-model:value="form.data.name"
                       class="form_input" placeholder="Name"
                       :maxlength="100" :show-count="form.data.name.length>0"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="12" :xl="4">
            <a-form-item name="mail" has-feedback>
              <a-input v-model:value="form.data.mail"
                       class="form_input" placeholder="Email address"
                       :maxlength="100" :show-count="form.data.mail.length>0"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="12" :xl="4">
            <a-form-item name="concern" has-feedback>
              <a-auto-complete v-model:value="form.data.concern" :options="expand.concern"
                               class="form_input">
                <a-input v-model:value="form.data.concern"
                         class="form_input" placeholder="Concern"
                         :maxlength="200" :show-count="form.data.concern.length>0"
                         allow-clear />
                <template #option="item">
                  <span>{{ item.value }}</span>
                </template>
              </a-auto-complete>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="12" :xl="4">
            <a-form-item name="industry" has-feedback>
              <a-input v-model:value="form.data.industry"
                       class="form_input" placeholder="Industry"
                       :maxlength="200" :show-count="form.data.industry.length>0"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="12" :xl="4">
            <a-form-item name="demands" has-feedback>
              <a-input v-model:value="form.data.demands"
                       class="form_input" placeholder="Demands"
                       :maxlength="140" :show-count="form.data.demands.length>0"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="12" :xl="{offset:1,span:3}">
            <a-form-item>
              <a-button type="link" class="button_n_1"
                        @click="submit">
                Confirm
              </a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <PageFooterBanner type="overseas" />
      <a-row class="box_info">
        <a-col :xs="24" :md="12">
          <PhoneOutlined :rotate="90" />
          Tel:&nbsp;&nbsp;010-53655900
          <span v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)" class="line">|</span>
          <br v-else />
          <MailOutlined />
          Email:&nbsp;&nbsp;market@galaxy-future.com
        </a-col>
        <a-col :xs="24" :md="12">
          <div class="box_channel">
            <a-popover v-for="item in expand.icon">
              <template #content>{{ item.title }}</template>
              <a-button type="link" target="_blank"
                        :href="item.href">
                <span class="iconfont" :class="`icon-${item.name}`" />
              </a-button>
            </a-popover>
          </div>
        </a-col>
      </a-row>
      <div class="record">
        <Footer />
      </div>
    </div>
  </footer>
</template>

<script lang="ts" type="text/tsx">
import {
  PhoneOutlined, MailOutlined
} from '@ant-design/icons-vue';

import { DataInterface } from '@interface/public';
import Footer from '@template/_component/footer.vue';
import PageFooterBanner from '@template/page/_component/banner.vue';

export default {
  name: 'overseas_footer',
  components: {
    PhoneOutlined,
    MailOutlined,
    Footer,
    PageFooterBanner
  },
  data(): DataInterface {
    return {
      form: {
        rule: {
          name: [
            {
              required: true,
              trigger: [
                'change',
                'blur'
              ],
              message: 'Specify a name.'
            }
          ],
          mail: [
            {
              required: true,
              trigger: [
                'change',
                'blur'
              ],
              message: 'Specify an email address.'
            }
          ],
          concern: [
            {
              required: true,
              trigger: [
                'change',
                'blur'
              ],
              message: 'Specify a concern.'
            }
          ],
          industry: [
            {
              required: true,
              trigger: [
                'change',
                'blur'
              ],
              message: 'Specify an industry.'
            }
          ],
          demands: [
            {
              required: true,
              trigger: [
                'change',
                'blur'
              ],
              message: 'Specify an demands.'
            }
          ]
        },
        data: {
          name: '',
          mail: '',
          concern: '',
          industry: '',
          demands: ''
        }
      },
      expand: {
        icon: [
          {
            title: 'GalaxyFuture GitHub',
            name: 'github',
            href: 'https://github.com/galaxy-future'
          }
        ],
        concern: [
          {
            value: 'Cost'
          },
          {
            value: 'O&M'
          },
          {
            value: 'Stability'
          }
        ]
      }
    };
  },
  methods: {
    /**
     * 提交
     */
    async submit(): Promise<any> {
      await this.$refs.form.validateFields()
        .then(async () => {
          await $RQ.PushWebHook(
            this.form.data.name,
            $Enum.TextEnum.OperateOverseasSubmit + '（' +
            Object.keys(this.form.data).reduce((t: string, v: string, i: number) => `${ t }${ i === 0 ? '' : '，' }${ v }：${ this.form.data[v] }`, '') + '）'
          );
          $FN.Message('success', {
            content: 'Submit Success!'
          });
          this.$refs.form.resetFields();
        })
        .catch(() => {
          $FN.Message('error', {
            content: 'Please verify information integrity!'
          });
        });
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}overseas/public/';

.footer {
  overflow: hidden;
  position: relative;
  z-index: 0;
  width: 100%;
  padding: 0 @padding;
  .bg('@{image}footer_bg.png');
  background-size: cover;
  
  .container {
    overflow: hidden;
    position: relative;
    max-width: @grid_xl;
    padding: 35px 0 0;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(left, @title+@line, @color_white, @title, true);
}

.box_form {
  margin: @margin 0 0;
  
  &:deep(.ant-form-item) {
    .ant-form-item-control-input {
      width: 90%;
    }
    
    .ant-select-selector,
    .ant-select-selection-search-input {
      height: 40px;
      
      .ant-select-selection-placeholder,
      .ant-select-selection-item {
        line-height: 38px;
      }
    }
  }
  
  .form_input,
  .form_select {
    height: 40px;
    border-radius: 4px;
  }
  
  .button_n_1 {
    width: 100% !important;
  }
}

.box_info {
  margin: @margin 0 0;
  .font(left, @text+@line, fade(@color_white, 90), @text);
  
  .line {
    margin: 0 10px;
  }
}

.box_channel {
  text-align: right;
  
  a {
    @as: 24px;
    height: @as;
    padding: 0;
    margin-right: 15px;
    .font(left, @as, fade(@color_white, 90), @as);
    
    .iconfont {
      font-size: @as;
    }
  }
}

.record {
  position: relative;
  width: 100%;
  padding: 15px 0;
  .font(left, 30px, fade(@color_white, 90), @font_7);
  
  &:deep(span) {
    color: @color_white;
  }
}

@media screen and (max-width: -1px+@grid_md) {
  h1.ant-typography {
    .font(left, @title_mo+@line_mo, @color_white, @title_mo, true);
  }
  
  .box_form {
    margin: @margin_mo 0 0;
    
    &:deep(.ant-form-item) {
      .ant-form-item-control-input {
        width: 100%;
      }
    }
  }
  
  .box_info {
    margin: @margin_mo 0 0;
    .font(left, @text_mo+@line_mo, fade(@color_white, 90), @text_mo);
  }
  
  .box_channel {
    margin: @margin_mo 0 0;
    text-align: left;
  }
  
  .record {
    text-align: center;
  }
  
}
</style>